var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pm-3d-animation-viewer',{attrs:{"animation-data":_vm.animationData,"title":_vm.title},model:{value:(_vm.animationViewDialog),callback:function ($$v) {_vm.animationViewDialog=$$v},expression:"animationViewDialog"}})}
var staticRenderFns = []

export { render, staticRenderFns }